import React, { useEffect, useState } from "react";
import { Country } from "country-state-city";
import CustomDropdown from "./CustomDropdown";
import MultiRangeSlider from "multi-range-slider-react";
import {
  genderOptions,
  languageOptions,
  segmenteOptions,
  sexualOrientationOptions,
  subscriptionTypeOptions,
} from "../../utils/data";

const SegmentDropdown = ({
  errorObj,
  setErrorObj,
  selectedSegment,
  setSelectedSegment,
  selectedValue,
  setSelectedValue,
}) => {
  const [minValue, set_minValue] = useState();
  const [maxValue, set_maxValue] = useState();

  const countryOptions = Country?.getAllCountries()?.map(
    (country) => country.name
  );

  const handleSegmentChange = (e) => {
    setSelectedSegment(e.target?.value);
    setErrorObj({
      sagment: "",
    });
  };
  useEffect(() => {
    set_minValue(selectedValue?.split("-")[0] || 18);
    set_maxValue(selectedValue?.split("-")[1] || 100);
  }, [selectedValue]);

  const handleInput = (e) => {
    set_minValue(e.minValue);
    set_maxValue(e.maxValue);
    setSelectedValue(`${e.minValue}-${e.maxValue}`);
  };

  const renderSegmentOptions = () => {
    switch (selectedSegment) {
      case "age":
        return (
          <div className="col-md-12 mb-3">
            <div className="form-group">
              <label className="mb-2 ct_fw_600">Select Age (18-100)</label>
              <MultiRangeSlider
                className="ct_multi_range_slide_12"
                min={18}
                max={100}
                step={5}
                minValue={minValue}
                maxValue={maxValue}
                onInput={(e) => {
                  handleInput(e);
                }}
              />
              {/* <input
                type="range"
                min="18"
                max="100"
                value={selectedValue || 18}
                onChange={handleInputChange}
                className="form-range"
              />
              <span className="ms-2">{selectedValue ?? ''}</span> */}
            </div>
            {errorObj && errorObj[selectedSegment] && (
              <span style={{ color: "red" }}>{errorObj[selectedSegment]}</span>
            )}
          </div>
        );
      case "gender":
        return (
          <CustomDropdown
            label="Gender"
            errorObj={errorObj}
            options={genderOptions}
            selectedValue={selectedValue}
            selectedSegment={selectedSegment}
            setSelectedValue={setSelectedValue}
          />
        );
      case "sexual_orientation":
        return (
          <CustomDropdown
            label="Sexual Orientation"
            errorObj={errorObj}
            options={sexualOrientationOptions}
            selectedValue={selectedValue}
            selectedSegment={selectedSegment}
            setSelectedValue={setSelectedValue}
          />
        );
      case "country":
        return (
          <CustomDropdown
            label="Country"
            errorObj={errorObj}
            options={countryOptions}
            selectedValue={selectedValue}
            selectedSegment={selectedSegment}
            setSelectedValue={setSelectedValue}
          />
        );
      case "language":
        return (
          <CustomDropdown
            label="Language"
            errorObj={errorObj}
            options={languageOptions}
            selectedValue={selectedValue}
            selectedSegment={selectedSegment}
            setSelectedValue={setSelectedValue}
          />
        );
      case "subscription_type":
        return (
          <CustomDropdown
            label="Subscription Type"
            errorObj={errorObj}
            options={subscriptionTypeOptions}
            selectedValue={selectedValue}
            selectedSegment={selectedSegment}
            setSelectedValue={setSelectedValue}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="col-md-12">
      {/* Segment Dropdown */}
      <div className="form-group mb-3">
        <label className="mb-2 ct_fw_600">Segment</label>
        <select
          className="form-control"
          value={selectedSegment || ""} // Ensuring the default option is selected if empty
          onChange={handleSegmentChange}
        >
          <option value="">Select an option</option>
          {segmenteOptions?.map((option) => (
            <option key={option?.value} value={option?.value}>
              {option?.label}
            </option>
          ))}
        </select>
        {errorObj?.sagment && (
          <span style={{ color: "red" }}>{errorObj.sagment}</span>
        )}
      </div>

      {/* Render Selected Segment Options */}
      {renderSegmentOptions()}
    </div>
  );
};

export default SegmentDropdown;
